// Error Codes

export default {
  PATH_TUTORIAL: "/tutorial",
  PATH_DASHBOARD: "/dashboard",
  PATH_LOGIN: "/login",
  PATH_REGISTER: "/register",
  PATH_CREATE_ABHA: "/create",
  PATH_ABHA_PROFILE: "/abhaProfile",
  PATH_LANDING: "/landing-page",
  PATH_ADD_NEW_REWARD: "/add-new-award",
  PATH_VIEW_DETAILS: "/view-details",

  PATH_PROFILE: "/profile",
  PATH_ASSETS: "/assets",
  PATH_SERVERS: "/servers",
  PATH_PROJECTS: "/projects",
  PATH_LICENSES: "/licenses",
  PATH_CONTRACTS: "/contracts",
  PATH_RESPONSE: "/response",
  PATH_VENDORS: "/vendor",
  PATH_TENANTS: "/tenant",
  PATH_USERS: "/users",
  PATH_VULNERABILITIES: "/vulnerabilities",

  PATH_CONTRACT_RESOURCES: "/contract-resources",
  PATH_LOGS: "/logs",

  // urls:
  LOGIN_URL: "https://eservicing.manipalcigna.com/login",
  HINDI_URL: "https://www.manipalcigna.com/hindi",

  //component
  CHECKBOX: "CHECKBOX",
  RADIO: "RADIO",
  TEXT: "TEXT",
  LABEL: "LABEL",
  // api
  API_SEND_OTP: "sendOtp",
  API_RE_SEND_OTP: "resendOtp",
  API_AUTHENTICATE_OTP: "authenticate",
  API_RENEW_TOKEN: "renewToken",
  API_LOGOUT: "logout",

  // session storage keys
  SS_KEY_GROUP_ACCESS_TOKEN: "_rat",
  SS_KEY_GROUP_ACCESS_TOKEN_EXPIRESBY: "_rate",
  SS_KEY_GROUP_REFRESH_TOKEN_EXPIRESBY: "_rrte",
  SS_KEY_GROUP_REFRESH_TOKEN: "_rrt",
  SS_KEY_GROUP_USER_ROLE: "_ur",
  SS_KEY_GROUP_USER_EMAIL: "_ue",

  //roles
  MANAGER: "MANAGER",
  DPL: "DPL",
  USER: "USER",
  CASE_OWNER: "CASE_OWNER",
  LEGAL_MANAGER: "LEGAL_MANAGER",
  CHECKER: "CHECKER",
  HOD: "HOD",
  GRIEVANCE: "GRIEVANCE",
  CLAIMS: "CLAIMS",
  OPERATIONS: "OPERATIONS",
  UNDERWRITING: "UNDERWRITING",

  ACTIVE: "ACTIVE",
  CLOSED: "CLOSED",
  REOPENED: "REOPENED",

  // status
  LOST: "LOST",
  SETTLEMENT: "SETTLEMENT",
};

export const File_Validation = [
  "application/pdf",
  "image/png",
  "image/jpeg",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const File_MAX_SIZE = 5 * 1024 * 1024; // 5MB in bytes;
export const formOrCourtArr = [
  "Insurance Ombudsman",
  "District Consumer Commission",
  "Permanent Lok Adalat",
  "State Consumer Commission",
  "National Commission",
  "High Court",
  "Civil Court",
  "Supreme Court",
  "Others",
];
export const stateArray = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi (National Capital Territory)",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];
